import React from 'react';
import './CardPublicidad.css';
import imgPublicidad from '../../../assets/img/cursos/estudiante.png';

const beneficios = [
    {
        title: 'Duración corta',
        text: 'Aprende en menos tiempo, con grandes resultados.',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="9" />
                <path d="M12 7v5l3 2" />
            </svg>
        ),
    },
    {
        title: 'Certificación',
        text: 'Acredita tus conocimientos y potencia tu perfil laboral.',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="8" r="4" />
                <path d="M6 20v-2a6 6 0 0 1 12 0v2" />
            </svg>
        ),
    },
    {
        title: 'Modalidad flexible',
        text: 'Presencial o virtual, según tu disponibilidad.',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <path d="M4 10h16" />
            </svg>
        ),
    },
    {
        title: 'Más oportunidades',
        text: 'Fortalece tu hoja de vida y da el siguiente paso.',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M7 17L17 7M9 7h8v8" />
            </svg>
        ),
    },
];

const CardPublicidad = () => {
    return (
        <section className="publi" aria-labelledby="publi-title">
            <div className="publi__hero">
                

                <div className="publi__grid">
                    <div className="publi__copy">
                        <p className="publi__kicker">Cursos cortos</p>
                        <h1 id="publi-title" className="publi__title">
                            Aprende hoy,
                            <br />
                            aplica mañana
                        </h1>
                        <p className="publi__lead">
                            Nuestros cursos cortos te brindan herramientas prácticas
                            para fortalecer tus habilidades y abrir nuevas oportunidades
                            laborales en el menor tiempo posible.
                        </p>
                        <a className="publi__cta" href="#cursos">
                            Explora nuestros cursos
                        </a>
                    </div>

                    <div className="publi__visual">
                        <img
                            src={imgPublicidad}
                            alt="Estudiante del Instituto de Educación Cruz Roja Sucre"
                            className="publi__img"
                        />
                    </div>
                </div>
            </div>

            <ul className="publi__features">
                {beneficios.map((item) => (
                    <li key={item.title} className="publi__feature">
                        <span className="publi__icon" aria-hidden="true">
                            {item.icon}
                        </span>
                        <div>
                            <h2>{item.title}</h2>
                            <p>{item.text}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default CardPublicidad;